import React from "react";

function Footer() {
    return(
        <footer className="bg-[#222831] text-gray-400 p-4 mt-8">
            <div className="container mx-auto text-center">
                <p>&copy; 2023 Unito. All rights reserved.</p>
                
            </div>
        </footer>
    );
}

export default Footer;